import {apiVersion} from '.';

const v2BaseURL = `${apiVersion.v2}/App`;

export const {getServices} = {
    getServices: `${v2BaseURL}/GetApps`,
};
